<div class="dialog-wrapper">
  <h2 mat-dialog-title>{{ data.title | translate }}</h2>
  <div mat-dialog-content>
    <span class="text">{{ data.text | translate }}</span>
    @if(data.type == 'prompt') {
      <mat-form-field appearance="outline">
        <input type="text" matInput [(ngModel)]="data.value">
      </mat-form-field>
    }
  </div>
  @if((data.list?.length ?? 0) > 0) {
    <ul>
      @for(item of data.list; track item) {
        <li>{{item}}</li>
      }
    </ul>
  }
  <div mat-dialog-actions>
    <div style="width: 100%; text-align: center">
      @if(data.type == 'prompt') {
        <div style="width: 100%; text-align: center">
          <button mat-raised-button (click)="onClick()">
            <mat-icon>arrow_right</mat-icon>
            <span>{{ button_save! | translate }}</span>
          </button>
          <button mat-raised-button (click)="onNoClick()">
            <mat-icon>arrow_right</mat-icon>
            <span>{{ button_cancel! | translate }}</span>
          </button>
        </div>
      }
      @if(data.type == 'confirm') {
        <div style="width: 100%; text-align: center; display: flex;">
          <br />
          <button mat-raised-button (click)="onClick()">
            <mat-icon>arrow_right</mat-icon>
            <span>{{ text_yes! | translate }}</span>
          </button>
          <button mat-raised-button (click)="onNoClick()">
            <mat-icon>arrow_right</mat-icon>
            <span>{{ text_no! | translate }}</span>
          </button>
        </div>
      }
      @if(data.type == 'alert') {
        <div>
          <br />
          <button mat-raised-button (click)="onClick()">
            <mat-icon>arrow_right</mat-icon>
            <span>OK</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>